
import { Helmet, HelmetProvider } from 'react-helmet-async';
import HeroBanner from '../components/WhatWeDo/HeroBanner'
import BannerSection from '../components/WhatWeDo/BannerSection';
import ImageTabs from '../components/WhatWeDo/ImageTabs'
import CardSection from '../components/WhatWeDo/CardSection'


const WhatWeDo = () => {
  return (
    <>
      <HelmetProvider>
      <Helmet>
        <title>What We Do | Brand Acumen</title>
        <meta name="description" content="Welcome to the homepage of Brand Acumen." />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Home | Brand Acumen" />
        <meta property="og:description" content="Welcome to the homepage of Brand Acumen." />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:url" content="https://brandacumen.co/" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:title" content="Home | Brand Acumen" />
        <meta name="twitter:description" content="Welcome to the homepage of Brand Acumen." />
        <meta name="twitter:image" content="/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
        <HeroBanner />    
        <BannerSection />
        <ImageTabs />
        <CardSection />
        </HelmetProvider>
    </>
  );
};

export default WhatWeDo;